
<template>
  <div class="toCheck_box">
    <!-- 检测报告 -->
    <div class="check_box">
      <div class="head_bg">
        <div class="flex">
          <p class="head_name">{{userInfo.name}}</p>
        </div>
        <div class="userInfo">
          <ul>
            <li>
              <p class="userkey">手机号码:</p>
              <p class="userValue">{{userInfo.mobile?util.checkPhone(userInfo.mobile):''}}</p>
            </li>
            <li>
              <p class="userkey">身份证号:</p>
              <p class="userValue">{{userInfo.idCard?util.checkIdCard(userInfo.idCard,6,4):''}}</p>
            </li>
            <li>
              <p class="userkey">查询时间:</p>
              <p class="userValue">{{userInfo.gmtCreated?userInfo.gmtCreated.substr(0,10):''}}</p>
            </li>
          </ul>
        </div>
        <div class="item grad">
          数据来源第三方机构，帮用户检测信息安全和了解借贷问题<br><span class="color_bg">建议15天检测一次，维护个人信用，借钱从此无忧</span>
        </div>
        <p class="title psTitle"><span class="left_icon"></span>借贷风险检测<span class="right_icon"></span></p>
      </div>
      <div class="item blue">
        <p class="subtitle sub16"><span class="subtitle_icon"></span>信贷逾期黑名单</p>
        <p class="info"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.blackPhone}"></span>手机号</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.blackPhone}">{{changeStatus(blackInfo.blackPhone)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.blackIdCard}"></span>身份证</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.blackIdCard}">{{changeStatus(blackInfo.blackIdCard)}}</p>
            </div>
          </div>
          <div class="jd_box">
            <span class="jd">解读</span>
            骗贷、逾期等不良贷款行为都可能会上信贷逾期黑名单。此类借款人被拒可能性非常高。
          </div>
        </div>
      </div>
      <div class="item blue">
        <p class="subtitle sub16"><span class="subtitle_icon"></span>信贷逾期灰名单</p>
        <p class="info"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.greyPhone}"></span>手机号</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.greyPhone}">{{changeStatus(blackInfo.greyPhone)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.greyIdCard}"></span>身份证</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.greyIdCard}">{{changeStatus(blackInfo.greyIdCard)}}</p>
            </div>
          </div>
          <div class="jd_box">
            <span class="jd">解读</span>
            短期逾期或其他不良贷款行为可能会上信贷逾期灰名单。贷款机构对此类借款人的审查会更严格。
          </div>
        </div>
      </div>
      <div class="item blue">
        <p class="subtitle sub16"><span class="subtitle_icon"></span>高风险关注名单</p>
        <p class="info"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.focusPhone}"></span>手机号</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.focusPhone}">{{changeStatus(blackInfo.focusPhone)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.focusIdCard}"></span>身份证</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.focusIdCard}">{{changeStatus(blackInfo.focusIdCard)}}</p>
            </div>
          </div>
          <div class="jd_box">
            <span class="jd">解读</span>
            提交的借款资质与实际不符，或存在贷款展期等高风险行为，可能会上高风险关注名单。贷款机构对此类借款人的审查会更严格。
          </div>
        </div>
      </div>
      <p class="title"><span class="left_icon"></span>逾期详情检测<span class="right_icon"></span></p>
      <div class="item blue">
        <p class="subtitle sub16"><span class="subtitle_icon"></span>逾期高风险</p>
        <p class="info">逾期90天以上未还，或出现失联情况</p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.bankCreditCard}"></span>银行类(含信用卡)</p>
              <p class="item_time"
                 v-if="lateRiskDTO.bankCreditCardTime">拒今 {{lateRiskDTO.bankCreditCardTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.bankCreditCard}">{{changeStatus(lateRiskDTO.bankCreditCard)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.licenseNetSmallLoan}"></span>持牌网络小贷</p>
              <p class="item_time"
                 v-if="lateRiskDTO.licenseNetSmallLoanTime">拒今 {{lateRiskDTO.licenseNetSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.licenseNetSmallLoan}">{{changeStatus(lateRiskDTO.licenseNetSmallLoan)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.licenseSmallLoan}"></span>持牌小贷</p>
              <p class="item_time"
                 v-if="lateRiskDTO.licenseSmallLoanTime">拒今 {{lateRiskDTO.licenseSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.licenseSmallLoan}">{{changeStatus(lateRiskDTO.licenseSmallLoan)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.licenseConsumerFinance}"></span>持牌消费金融</p>
              <p class="item_time"
                 v-if="lateRiskDTO.licenseConsumerFinanceTime">拒今 {{lateRiskDTO.licenseConsumerFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.licenseConsumerFinance}">{{changeStatus(lateRiskDTO.licenseConsumerFinance)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.licenseFinanceLease}"></span>持牌融资租赁</p>
              <p class="item_time"
                 v-if="lateRiskDTO.licenseFinanceLeaseTime">拒今 {{lateRiskDTO.licenseFinanceLeaseTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.licenseFinanceLease}">{{changeStatus(lateRiskDTO.licenseFinanceLease)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':lateRiskDTO.licenseAutoFinance}"></span>持牌汽车金融风险</p>
              <p class="item_time"
                 v-if="lateRiskDTO.licenseAutoFinanceTime">拒今 {{lateRiskDTO.licenseAutoFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':lateRiskDTO.licenseAutoFinance}">{{changeStatus(lateRiskDTO.licenseAutoFinance)}}</p>
            </div>
          </div>
          <div class="dash"></div>
          <!-- <div class="item_info">
            解读：<br>
            1、风险信息扫描主要针对过往的行为进行评估，主要体现在曾经有过不良行为，包括但不限于网络贷款、银行贷款、助学贷款、行业金融未支付等。<br>
            2、请不要使用非正规手段恶意刷单、薅羊毛。<br>
            3、请端正思想，不要恶意套现或盗用他人信息。<br>
            4、请不要随意泄露个人信息，尤其是不明身份来源，谨防信息被盗用！<br>
          </div> -->
        </div>
        <p class="subtitle sub16"><span class="subtitle_icon"></span>逾期中风险</p>
        <p class="info">逾期30~90天内未还</p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.bankCreditCard}"></span>银行类(含信用卡)</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.bankCreditCardTime">拒今 {{overdueRiskDTO.bankCreditCardTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.bankCreditCard}">{{changeStatus(overdueRiskDTO.bankCreditCard)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.licenseNetSmallLoan}"></span>持牌网络小贷</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.licenseNetSmallLoanTime">拒今 {{overdueRiskDTO.licenseNetSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.licenseNetSmallLoan}">{{changeStatus(overdueRiskDTO.licenseNetSmallLoan)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.licenseSmallLoan}"></span>持牌小贷</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.licenseSmallLoanTime">拒今 {{overdueRiskDTO.licenseSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.licenseSmallLoan}">{{changeStatus(overdueRiskDTO.licenseSmallLoan)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.licenseConsumerFinance}"></span>持牌消费金融</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.licenseConsumerFinanceTime">拒今 {{overdueRiskDTO.licenseConsumerFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.licenseConsumerFinance}">{{changeStatus(overdueRiskDTO.licenseConsumerFinance)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.licenseFinanceLease}"></span>持牌融资租赁</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.licenseFinanceLeaseTime">拒今 {{overdueRiskDTO.licenseFinanceLeaseTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.licenseFinanceLease}">{{changeStatus(overdueRiskDTO.licenseFinanceLease)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':overdueRiskDTO.licenseAutoFinance}"></span>持牌汽车金融风险</p>
              <p class="item_time"
                 v-if="overdueRiskDTO.licenseAutoFinanceTime">拒今 {{overdueRiskDTO.licenseAutoFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':overdueRiskDTO.licenseAutoFinance}">{{changeStatus(overdueRiskDTO.licenseAutoFinance)}}</p>
            </div>
          </div>
          <div class="dash"></div>
        </div>
        <p class="subtitle sub16"><span class="subtitle_icon"></span>资质不佳</p>
        <p class="info">曾有申请材料虚假情况，如身份伪冒或不良机构包装代办</p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2 borderTop">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.bankCreditCard}"></span>银行类(含信用卡)</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.bankCreditCardTime">拒今 {{poorQualificationDTO.bankCreditCardTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.bankCreditCard}">{{changeStatus(poorQualificationDTO.bankCreditCard)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.licenseNetSmallLoan}"></span>持牌网络小贷</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.licenseNetSmallLoanTime">拒今 {{poorQualificationDTO.licenseNetSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.licenseNetSmallLoan}">{{changeStatus(poorQualificationDTO.licenseNetSmallLoan)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.licenseSmallLoan}"></span>持牌小贷</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.licenseSmallLoanTime">拒今 {{poorQualificationDTO.licenseSmallLoanTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.licenseSmallLoan}">{{changeStatus(poorQualificationDTO.licenseSmallLoan)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.licenseConsumerFinance}"></span>持牌消费金融</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.licenseConsumerFinanceTime">拒今 {{poorQualificationDTO.licenseConsumerFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.licenseConsumerFinance}">{{changeStatus(poorQualificationDTO.licenseConsumerFinance)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.licenseFinanceLease}"></span>持牌融资租赁</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.licenseFinanceLeaseTime">拒今 {{poorQualificationDTO.licenseFinanceLeaseTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.licenseFinanceLease}">{{changeStatus(poorQualificationDTO.licenseFinanceLease)}}</p>
            </div>
            <div class="flex bg1 borderBottom">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':poorQualificationDTO.licenseAutoFinance}"></span>持牌汽车金融风险</p>
              <p class="item_time"
                 v-if="poorQualificationDTO.licenseAutoFinanceTime">拒今 {{poorQualificationDTO.licenseAutoFinanceTime}} 年</p>
              <p class="item_value"
                 :class="{'item_value_red':poorQualificationDTO.licenseAutoFinance}">{{changeStatus(poorQualificationDTO.licenseAutoFinance)}}</p>
            </div>
          </div>
        </div>
      </div>

      <p class="title"><span class="left_icon"></span>建议<span class="right_icon"></span></p>
      <div class="item blue">
        <p class="subtitle"><span class="subtitle_icon"></span>非恶意欠款</p>
        <div class="item_notice">
          多数人逾期并不是因为故意违约欠款，往往是因为除正常还款外其它费用未还而导致的逾期。比如：年费、利息、滞纳金等。有时等到注销信用卡的时候才被告知有逾期。出现这种情况，持卡人可以缴清欠款，并向发卡行申诉非恶意欠款，说明原因。这种操作有一定的几率消除个人不良逾期记录。
        </div>
        <div class="mg">
          <p class="subtitle"><span class="subtitle_icon"></span>第三方还款失败</p>
          <div class="item_con">
            <div class="item_notice">
              当我们还款的时候有时会选择第三方还款，第三方还款有时不是实时到账，比如跨行转账、网银转账还款失败和绑定跨行自动扣款失败。信用卡跨行扣款会经过第三方支付转账，而有的第三方机构对转账额度有限制，所以这种情况可以申请银行消除逾期记录。
            </div>
          </div>
        </div>
        <div class="mg">
          <p class="subtitle"><span class="subtitle_icon"></span>小额欠款未还</p>
          <div class="item_notice">
            大对数人还款都可能是按整数来还，一些零头就不会太注意，所以容易成逾期，现在银行一般都会有一个容差，只要你未还部分少于10元（不同银行要求不一样），银行是将不会算作逾期，如果哪个银行记录逾期了，可以要求银行消除。 </div>
        </div>
        <div class="mg">
          <p class="subtitle"><span class="subtitle_icon"></span>不实信息导致的逾期</p>
          <div class="item_notice">
            有时候逾期不是个人原因，是因为银行审核不严，导致个人信息被冒用，或信息有误，这些情况都可以去当地的中国人民银行提出异议申请，通常15个工作日之内，就可以拿到答复，这种不良逾期也会立即消除。
          </div>
        </div>
        <div class="mg">
          <p class="subtitle"><span class="subtitle_icon"></span>总结</p>
          <div class="item_notice">
            并不是所有逾期都可以消除，但是有一点可以确定的是如果你不及时消除逾期，逾期一定会一直存在。当你想要贷款，用到个人征信的话，如果你有逾期，小则影响贷款额度，大则直接拒贷。对于急用钱的你这样恐怕不是好消息，大家还是多注意，尽量不要有逾期。结清欠款后，请保持良好的借贷行为，提升信用。
          </div>
        </div>
        <div class="mg mg36">
          <div class="item_notice">
            1、此报告是由用户本人授权查询。<br>
            2、报告内容以第三方平台数据为依据，报告仅供参考，据此作出的决策均为用户独立的判断，产生的一切结果均由用户独立承担，本平台不承担任何责任。<br>
            3、为了用户的数据安全，本平台不保存任何相关数据，如有需要，请用户自主保存信息。
          </div>
        </div>
        <img class="bottom_bg"
             src="../../assets/img/vip/majorCheck/checkBoxVip_bgb.png"
             alt="">
      </div>
    </div>
  </div>
</template>

<script>
import PayToast from '@/components/payToast';
export default {
  components: {
    PayToast
  },
  data () {
    return {
      isSpecial: 1,
      dataList2: [10, 130, 320, 450],
      eventKey: 'h5_blacklist_view',
      userInfo: {
        mobile: '',
        idCard: '',
        gmtCreated: '',
        name: ''
      },
      score: 0,//是否可以检测
      blackInfo: {},//借贷信息
      isShowEchart: true,
      lateRiskDTO: {},
      overdueRiskDTO: {},
      poorQualificationDTO: {},
    }
  },
  mounted () {
    this.util.title('个人信用评估');
    this.getHitInfo();//获取检测信息
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getHitInfo () {
      let _this = this;
      this.$get('/app/h5/blackList/threeHitInfo')
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.userInfo = e.data.byConsumerId;
            _this.blackInfo = e.data.blackInfo;
            _this.lateRiskDTO = e.data.blackInfo.lateRiskDTO
            _this.overdueRiskDTO = e.data.blackInfo.overdueRiskDTO
            _this.poorQualificationDTO = e.data.blackInfo.poorQualificationDTO
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    changeStatus (val) {
      if (val) {
        return "命中"
      } else {
        return "未命中"
      }
    },
  }

}
</script>
<style scoped>
.check_box {
  position: relative;
  background: #001a56;
  padding-bottom: 0.37rem;
}
/* 检测报告 */
.check_box .head_bg {
  background: url('../../assets/img/vip/majorCheck/checkBoxVip_bg.png')
    no-repeat top center;
  background-size: 100% 100%;
  width: 100%;
  height: 3.3rem;
  font-size: 0.28rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  padding-top: 0.44rem;
}
.score {
  font-size: 0.34rem;
}
.score_img4,
.score_img1,
.score_img2,
.score_img3 {
  background: url('../../assets/img/vip/check/score_bg1.png') no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.48rem;
  height: 0.24rem;
  position: absolute;
  right: 0.25rem;
}
.score_img2 {
  background: url('../../assets/img/vip/check/score_bg2.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img3 {
  background: url('../../assets/img/vip/check/score_bg3.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img4 {
  background: url('../../assets/img/vip/check/score_bg4.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.head_name {
  padding: 0 0.17rem 0rem 0.2rem;
}
.userInfo {
  padding: 0 0.17rem 0rem 0.2rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.userInfo li {
  display: flex;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(151, 157, 174, 1);
  text-align: left;
  margin-bottom: 0.1rem;
}
.userInfo li:last-child {
  margin-bottom: 0;
}
.userInfo .userkey {
  color: #979dae;
  margin-right: 0.1rem;
}
.userInfo .userValue {
  color: #fff;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.psTitle {
  position: relative;
  top: 0.1rem;
}
.left_icon,
.right_icon {
  background: url('../../assets/img/vip/majorCheck/check_title_icon.png')
    no-repeat top center;
  background-size: 100% 100%;
  width: 0.16rem;
  display: inline-block;
  height: 0.1rem;
  margin-left: 0.1rem;
}
.left_icon {
  margin-right: 0.1rem;
  margin-left: 0;
}
.item {
  background: #272733;
  margin: 0.15rem 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  font-size: 0.12rem;
  padding: 0.12rem 0.1rem;
  position: relative;
}
.jd_box {
  font-size: 0.11rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-top: 0.13rem;
  padding-bottom: 0.15rem;
}
.jd {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 26, 86, 1);
  background: #59e3ff;
  text-align: center;
  padding: 0.01rem 0.03rem;
  border-radius: 2px;
}

.subtitle {
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  /* margin-bottom: 0.01rem; */
}
.sub16 {
  font-size: 0.16rem;
}
.subtitle_icon {
  display: inline-block;
  background: url('../../assets/img/vip/majorCheck/check_subtitle_icon.png')
    no-repeat top center;
  background-size: 100% 100%;
  width: 0.17rem;
  height: 0.24rem;
  margin-right: 0.03rem;
}
.info {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  padding-left: 0.2rem;
  margin: 0.14rem 0;
}
.blue {
  background: linear-gradient(
    360deg,
    rgba(67, 73, 192, 0) 0%,
    rgba(32, 35, 140, 1) 100%
  );
  padding-top: 0.15rem;
}
.gray {
  background: linear-gradient(
    360deg,
    rgba(67, 73, 192, 0) 0%,
    rgba(32, 35, 140, 1) 100%
  );
}
.grad {
  background: linear-gradient(
    270deg,
    rgba(255, 55, 29, 0) 0%,
    rgba(255, 58, 46, 0.86) 100%
  );
  border-radius: 0;
}
.comn_title7,
.comn_title1,
.comn_title2,
.comn_title3,
.comn_title4,
.comn_title5,
.comn_title6 {
  /* color: #fff;
  font-size: 0.14rem;
  padding: 0.14rem 0.15rem; */
  background: url('../../assets/img/vip/majorCheck/title_bg1.png') no-repeat top
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 1.74rem;
  height: 0.22rem;
  margin-bottom: 0.1rem;
}
.comn_title7 {
  background: url('../../assets/img/vip/majorCheck/title_bg7.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title2 {
  background: url('../../assets/img/vip/majorCheck/title_bg2.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title3 {
  background: url('../../assets/img/vip/majorCheck/title_bg3.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title4 {
  background: url('../../assets/img/vip/majorCheck/title_bg4.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title5 {
  background: url('../../assets/img/vip/majorCheck/title_bg5.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title6 {
  background: url('../../assets/img/vip/majorCheck/title_bg6.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.line_bg {
  display: inline-block;
  width: 0.04rem;
  height: 0.13rem;
  background: linear-gradient(
    135deg,
    rgba(89, 131, 252, 1) 0%,
    rgba(60, 113, 246, 1) 100%
  );
  position: relative;
  top: 0.015rem;
  margin-right: 0.05rem;
}
.item_con {
  /* padding: 0.15rem 0rem 0.2rem 0rem; */
  /* clear: both;
  overflow: hidden;
  margin-bottom: 0.2rem; */
}
.bottom_bg {
  width: 100%;
  position: absolute;
  bottom: 0;
  right: -0.1rem;
}
.item .box {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding-left: 0.5rem;
  padding-right: 0.3rem;
}
.mg {
  margin-top: 0.26rem;
}
.mg36 {
  margin-top: 0.36rem;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.item_key {
  font-size: 0.14rem;
  color: #fff;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  position: realtive;
  flex: 0.55;
}
.item_value {
  font-size: 0.14rem;
  color: #858abe;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  flex: 0.2;
  text-align: right;
}
.item_time {
  flex: 0.2;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.item_value_red {
  color: #ff3232;
}
.dash {
  border-bottom: 1px dashed #001a56;
  margin-top: 0.15rem;
  margin-bottom: 0.2rem;
}
.item_info {
  color: #979dae;
  font-size: 0.12rem;
  line-height: 23px;
  background: rgba(32, 32, 44, 1);
  border-radius: 6px;
  padding: 0.1rem;
  margin-top: 0.1rem;
}
.pd {
  padding: 0.13rem 0.1rem;
  line-height: 24px;
}
.color_bg {
  color: #ffe755;
  font-size: 0.12rem;
  background: rgba(255, 162, 73, 0.1);
}
.item_con .bg {
  border-radius: 6px;
}
.flex_box .bg2 {
  background: rgba(255, 255, 255, 0.1);
  padding: 0.1rem;
}
.flex_box .bg1 {
  background: rgba(4, 1, 91, 1);
  padding: 0.1rem;
}
.borderTop {
  border-radius: 6px 6px 0px 0px;
}
.borderBottom {
  border-radius: 0px 0px 6px 6px;
}
.item_notice {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 22px;
}
.item .box_con {
  font-size: 0.14rem;
  color: #fff;
  padding-top: 0.4rem;
}
.box_con .appColor {
  color: #4f8cfa;
}
.box_con .red {
  color: #ffd75c;
}
.squire,
.squire1 {
  display: inline-block;
  background: rgba(79, 140, 250, 1);
  border-radius: 2px;
  width: 0.2rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.squire1 {
  background: #8ee1ff;
}
.noData_box {
  height: 1rem;
}
.noData,
.noData1 {
  background: url('../../assets/img/vip/check/echarts_noData.png') no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.7rem;
  display: inline-block;
  height: 0.7rem;
  position: relative;
  top: 0.23rem;
}
.noData1 {
  background: url('../../assets/img/vip/majorCheck/echarts_noData1.png')
    no-repeat top center;
  background-size: 100% 100%;
}
.icon,
.icon1 {
  background: url('../../assets/img/vip/majorCheck/icon.png') no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.14rem;
  height: 0.14rem;
  display: inline-block;
  position: relative;
  margin-right: 5px;
  top: 0.01rem;
  left: 0;
}
.icon1 {
  background: url('../../assets/img/vip/majorCheck/icon2.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.progres {
  margin-top: 0.1rem;
}
.pro_item {
  display: flex;
  flex: 1;
  justify-content: space-around;
  font-size: 0.1rem;
  color: #979dae;
  margin-bottom: 0.1rem;
}
.grade {
  color: #5cf0e0;
  font-size: 0.12rem;
}
.grade1 {
  color: #1fcaff;
}
.grade2 {
  color: #336df7;
}
.per_icon1,
.per_icon2 {
  background: url('../../assets/img/vip/majorCheck/per_icon2.png') no-repeat top
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.57rem;
  height: 0.57rem;
  float: left;
}
.per_icon2 {
  background: url('../../assets/img/vip/majorCheck/per_icon1.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.per_con {
  /* display: flex; */
  /* flex: 1; */
  /* justify-content: space-between; */
  padding: 0 0.2rem;
  clear: both;
  overflow: hidden;
  font-size: 0.12rem;
  color: #979dae;
}
.ps {
  position: relative;
  top: 0.1rem;
}
.left_box .title {
  color: #56bdff;
  font-size: 0.14rem;
}
.right_box .title {
  color: #ffe755;
  font-size: 0.14rem;
}
.left_box,
.right_box {
  float: left;
  width: 50%;
}
</style>
<style >
.prg_bg .ivu-progress-bg {
  background-color: #5cf0e0;
}
.prg_bg1 .ivu-progress-bg {
  background-color: #1fcaff;
}
.prg_bg2 .ivu-progress-bg {
  background-color: #336df7;
}

.progress_bg {
  background: url('../../assets/img/vip/majorCheck/progress_bg.png') no-repeat
    top center;
  background-size: 100% 100%;
  width: 100%;
  height: 0.46rem;
  margin: 0.3rem auto;
  position: relative;
}
.progress_icon {
  background: url('../../assets/img/vip/majorCheck/progress_icon.png') no-repeat
    top center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  position: relative;
  left: 12%;
  top: -0.1rem;
}
.pr_32 {
  position: relative;
  left: 32%;
}
.pr_58 {
  position: relative;
  left: 58%;
}
.pr_85 {
  position: relative;
  left: 85%;
}
</style>